var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { MdArrowDropDown, MdKeyboardArrowDown } from 'react-icons/md';
import { Icon } from "./..";
import { useTheme } from "../../hooks";
export var ToggleIndicator = function (_a) {
    var isOpen = _a.isOpen, lss = _a.lss, isOutline = _a.isOutline;
    var theme = useTheme();
    return (React.createElement(Icon, { as: isOutline ? MdKeyboardArrowDown : MdArrowDropDown, size: isOutline ? 22 : 20, lss: __assign({ mt: '-4px', mb: !isOpen ? '-6px' : '-4px', mr: '-5px', ml: 'none', transition: "transform " + theme.transitions.fast + ", opacity " + theme.transitions.fast, transform: (isOpen ? 'rotate(-180deg)' : ''), color: isOutline && !isOpen ? 'primary500' : isOpen ? 'inherit' : 'gray600' }, lss) }));
};
//# sourceMappingURL=ToggleIndicator.js.map